import { render, staticRenderFns } from "./FolderMultipleImage.vue?vue&type=template&id=ee930c3a"
import script from "./FolderMultipleImage.vue?vue&type=script&lang=js"
export * from "./FolderMultipleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports